// extracted by mini-css-extract-plugin
var _1 = "DocFlowCombiningProgress-moduleloader__raFUr";
var _2 = "DocFlowCombiningProgress-moduletext__NLJFw PageEmptyState-moduletext__b_Fm3";
export { _1 as "loader", _2 as "text" }
